
export default {
  props: ['info'],
  data: () => {
    return {
      tableList: []
    };
  },

  computed: {
  },

  methods: {
    previewDetail() {
      this.$emit('preview');
    }
  }
};
